import { Grid, Paper, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

import { RouterLink } from 'main/components/_common/RouterLink';

export const Activity = () => {
    return (
        <Paper square>
            <Grid container direction="column" p={2}>
                <Grid item>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <CircleIcon fontSize="small" />
                        </Grid>
                        <Grid item>
                            <Typography fontSize={18}>活動日</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Typography variant="body2" ml={3}>土曜日、日曜日</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2" ml={3}>（午前、または、午後のどちらか半日のみ）</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2" ml={3}>
                        ※詳しくは<RouterLink path="/schedule">スケジュール</RouterLink>を確認下さい
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}
